<template>
    <div class="n-flex n-flex-a-c n-flex-dr-c n-flex-j-c n-h-1">
        <a-spin size="large" />
        <h1 class="n-col-1 n-text-center n-mt-6 n-c-base">正在跳转登录，请稍后</h1>
    </div>
</template>
<script >
    import { message } from 'ant-design-vue';
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    export default {
        name: 'Login',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setMenuStatus'])),

            NMounted () {
                var url = window.location.href,
                    param = this.queryUrlParam(url)

                setTimeout(() => {
                    if (param.code) {
                        this.request(this.API.authByCode, {
                            method: 'post',
                            data: { code: param.code }
                        }).then(res => {
                            if (res.code == this.REQUEST_SUCCESS_CODE) {
                                this.setUserInfo(res.data)
                                this.$router.replace({ name: this.HOME_URL_NAME })
                            } else {
                                this.$router.push({ name: 'noAuth' })
                            }
                        }).catch(() => {
                            message.error('登录失败，即将重新跳转登录');
                            setTimeout(this.auth, 2000);
                        })
                    } else {
                        this.auth()
                    }
                }, 1000);
            },
            auth () {
                window.location.href = this.AUTH_URL
            }
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss">
    .info-w {
        width: 160px;
    }
</style>